import {
  AcExpoDayPickerProps,
  CalendarDayPicker,
  MultipleRangeDayPicker,
} from "./day-picker";
import { Mode } from "react-day-picker";

type CalendarProps = AcExpoDayPickerProps;

const isBaseMode = (mode: CalendarProps["mode"]): mode is Mode =>
  ["multiple", "range", "single"].includes(mode ?? "");

function Calendar({ ...props }: CalendarProps) {
  if (props.mode === "multiple-range") {
    const { mode, required, ...propsWithoutMode } = props;
    return <MultipleRangeDayPicker {...propsWithoutMode} />;
  }
  if (isBaseMode(props.mode)) return <CalendarDayPicker {...props} />;
  return null; // unknown mode
}
Calendar.displayName = "Calendar";

export { Calendar };
